import { defineWebModule } from "../../web/module";
import { AccessPage } from "./web/Access";
import { ProgramJob } from "./web/Program";
import { ProvenanceSection, showProvenance } from "./web/Provenance";
import { DataWorkspace } from "./web/Workspace";
import { YourData } from "./web/YourData";
import "./web/data.css";

export default defineWebModule({
  id: "data",
  ranchSections: { data: YourData, access: AccessPage },
  workspaces: { data: DataWorkspace },
  jobs: { "data.program": ProgramJob },
  animalSections: [{ id: "data-source", label: "Where this came from", order: 95, show: showProvenance, Component: ProvenanceSection }],
});
